import { useState, useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Layout from "./Layout";
import { Context } from "../components/Context";
import Login from "../modules/home/Login";
import Registration from "../modules/auth/Registration";
import Dashboard from "../modules/dashboard/Dashboard"
import Cookies from 'universal-cookie';
import VoucherCampaign from "../modules/home/VoucherCampaign";
import GeneralCampaign from "../modules/home/GeneralCampaign";
import Voucher from "../modules/home/Voucher"; // DEPRECATED
import GiftCard from "../modules/home/GiftCard";
import RestrictedRoute from "./RestrictedRoute";
import { SCREEN_RESTRICTION_KEYS } from "./screen-restriction-keys";

function Routing() {
    const cookies = new Cookies();
    const navigate = useNavigate();
    const location = useLocation();
    const [context, setContext] = useState(cookies.get('user') ?? '');

    useEffect(() => {
        if (location.pathname.includes('/admin/') && (!context || !context.key || !context.key.auth_key)) {
            navigate('/')
        }
    }, [context])

    return (
        <Context.Provider value={[context, setContext]} >
            <Routes>
                <Route path="/" exact caseSensitive={false} element={<Layout />}>
                    <Route path="/" caseSensitive={false} element={<Login />} />
                </Route>

                {context && context.key && context.key.auth_key &&
                    <Route path="/admin/" caseSensitive={false} element={<Layout />}>
                        <Route
                            path="dashboard"
                            caseSensitive={false}
                            element={
                                <RestrictedRoute screenKey={SCREEN_RESTRICTION_KEYS.ADMIN_DASHBOARD}>
                                    <Dashboard />
                                </RestrictedRoute>
                            }
                        />
                        <Route
                            path="registration"
                            caseSensitive={false}
                            element={
                                <RestrictedRoute screenKey={SCREEN_RESTRICTION_KEYS.ADMIN_REGISTRATION}>
                                    <Registration />
                                </RestrictedRoute>
                            }
                        />
                    </Route>
                }

                <Route
                    path="/vc/:data_id"
                    caseSensitive={false}
                    element={
                        <RestrictedRoute screenKey={SCREEN_RESTRICTION_KEYS.VOUCHER_CAMPAIGN}>
                            <VoucherCampaign />
                        </RestrictedRoute>
                    }
                >
                    <Route
                        path=":value"
                        caseSensitive={false}
                        element={
                            <RestrictedRoute screenKey={SCREEN_RESTRICTION_KEYS.VOUCHER_CAMPAIGN}>
                                <VoucherCampaign />
                            </RestrictedRoute>
                        }
                    />
                </Route>

                <Route
                    path="/sp/:campaign_id/:barcode"
                    caseSensitive={false}
                    element={
                        <RestrictedRoute screenKey={SCREEN_RESTRICTION_KEYS.GIFT_CARD}>
                            <GiftCard />
                        </RestrictedRoute>
                    }
                />

                <Route
                    path="/gc/:data_id"
                    caseSensitive={false}
                    element={
                        <RestrictedRoute screenKey={SCREEN_RESTRICTION_KEYS.GENERAL_CAMPAIGN}>
                            <GeneralCampaign />
                        </RestrictedRoute>
                    }
                >
                    <Route
                        path=":value"
                        caseSensitive={false}
                        element={
                            <RestrictedRoute screenKey={SCREEN_RESTRICTION_KEYS.GENERAL_CAMPAIGN}>
                                <GeneralCampaign />
                            </RestrictedRoute>
                        }
                    />
                </Route>

                {/* DEPRECATED ROUTE */}
                <Route
                    path="/v/:value"
                    caseSensitive={false}
                    element={
                        <RestrictedRoute screenKey={SCREEN_RESTRICTION_KEYS.VOUCHER_LEGACY}>
                            <Voucher />
                        </RestrictedRoute>
                    }
                >
                    <Route
                        path=":expiry"
                        caseSensitive={false}
                        element={
                            <RestrictedRoute screenKey={SCREEN_RESTRICTION_KEYS.VOUCHER_LEGACY}>
                                <Voucher />
                            </RestrictedRoute>
                        }
                    />
                </Route>
            </Routes>
        </Context.Provider>
    )
}
export default Routing 